import dayjs from 'dayjs';

function displayDateTime (dateTimeStr: string | dayjs.Dayjs | number | Date): string {
	return dayjs(dateTimeStr).format('MM/DD/YYYY h:mm A');
}

export default {
	displayDateTime
};
